import React from 'react';
import icon1 from '../assets/servicesImages/webdev/icon1.png';
import icon2 from '../assets/servicesImages/webdev/icon2.png';
import icon3 from '../assets/servicesImages/webdev/icon3.png';
import icon4 from '../assets/servicesImages/webdev/icon4.png';
import icon5 from '../assets/servicesImages/webdev/icon5.png';
import icon6 from '../assets/servicesImages/webdev/icon6.png';
import Slider from 'react-slick';

const items = [
    {
        icon: icon1,
        title: 'Responsive Website Design',
        desc: 'Build stunning, mobile-friendly websites that adapt to any screen size, providing the best user experience.',
    },
    {
        icon: icon2,
        title: 'Static Website Design',
        desc: 'Simple websites without a backend for small businesses, quick to load and easy to manage.',
    },
    {
        icon: icon3,
        title: 'Dynamic Website Design',
        desc: 'Interactive websites that engage users, with dynamic content and data-driven features.',
    },
    {
        icon: icon4,
        title: 'Content Management System',
        desc: 'Easily manage your website’s content without any coding knowledge using a robust CMS.',
    },
    {
        icon: icon5,
        title: 'API Integration',
        desc: 'Enhance your website functionality with seamless API integrations from third-party services.',
    },
    {
        icon: icon6,
        title: 'E-Commerce',
        desc: 'Launch a full-fledged online store with payment gateways, product management, and more.',
    },
];

const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 3.5,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 2.5,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
};

const WebDevSection4 = () => {
    return (
        <div className="py-16 px-4">
        <div className="text-center mb-12">
            <p className="text-4xl font-semibold mb-4">
                Our Features
            </p>
            <p className="text-xl  opacity-80 max-w-2xl mx-auto">
                Explore our top-notch features designed to take your website to the next level.
            </p>
        </div>
    
        <Slider {...settings} className="overflow-hidden">
            {items.map((item, index) => (
                <div key={index} className="px-4">
                   <div className="bg-white rounded-xl shadow-[0px_10px_30px_rgba(0,0,0,0.15)] hover:shadow-[0px_15px_35px_rgba(0,0,0,0.2)] transform transition-all duration-300 p-6 mt-8 mb-5 hover:scale-[1.02]" style={{ height: '300px' }}>
    <div className="w-24 h-24 bg-blue-100 rounded-full mx-auto mb-6 flex justify-center items-center">
        <img src={item.icon} alt={item.title} className="w-16 h-16 object-contain" />
    </div>
    <p className="text-xl font-semibold text-gray-800 text-center mb-4 hover:text-blue-900">
        {item.title}
    </p>
    <p className="text-sm text-gray-600 text-center ">
        {item.desc}
    </p>
</div>

                </div>
            ))}
        </Slider>
    </div>
    
    );
};

export default WebDevSection4;
